module.exports = __webpack_public_path__ + "assets/img/31@3x.ca1863df.png";